import type { Questionnaire } from '@medplum/fhirtypes'

export const DietQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/demographics-diet',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Diet Demographics',
  title: 'Diet Needs and Support',
  item: [
    {
      linkId: 'diet',
      text: 'Diet',
      type: 'string',
    },
    {
      linkId: 'fluid-consistency',
      text: 'Fluid Consistency',
      type: 'text',
    },
    {
      linkId: 'fluid-restrictions',
      text: 'Fluid Restrictions (mL/d)',
      type: 'string',
    },
    {
      linkId: 'supplements',
      text: 'Supplements',
      type: 'string',
    },
    {
      linkId: 'dislikes',
      text: 'Dislikes',
      type: 'string',
    },
    {
      linkId: 'meets-nutritional-needs',
      text: 'Does participant have access to meals that meet daily nutritional and special dietary needs?',
      type: 'boolean',
    },
    {
      linkId: 'notes',
      text: 'Notes',
      type: 'text',
    },
  ] as const,
} satisfies Questionnaire
